
function addItemToCart() {
    const formData = $('#product-main-form').serialize();
    let quantity = formData.split("quantity=")[1];
    if (quantity.length > 4) {
        // Must have additional input values, get the quantity value only before the next &param=
        quantity = quantity.split("&")[0];
    }

    quantity = parseInt(quantity);

    $.ajax({
       type: 'POST',
       url: '/cart/add.js',
       dataType: 'json',
       data: formData,
       success: function(data) {
            addToCartOk(data, quantity);
       },
       error: addToCartFail
    });
}

function addToCartOk(product, quantity) {

   const productPrice = (product.final_price / 100).toFixed(2); // e.g. 2200 to 22.00
   const added = 'In den Warenkorb gelegt';
   const exVat = 'Exkl. MwSt.';
   const qty = 'Menge';
   const view = 'Warenkorb anzeigen';
   const continueShopping = 'Mit dem Einkauf fortfahren';

   $('.cart-preview-modal-content').html('<div><div style="font-size: 14px;">' + added + '</div><h2 style="margin-top: 4px; margin-bottom: 15px; font-weight: 700; color: #000000;">' + product.title + '</h2><div style="font-weight: bold; color: #000000;"><span style="margin-right: 20px;"><span style="font-size: 24px; color:#f77907;">€' + productPrice + '</span> ' + exVat + '</span>' + qty + ': ' + product.quantity + '</div></div>');
   $('.cart-preview-modal-content').append('<div><a href="/cart" class="view-basket-button">' + view + '</a><a onClick="closeModal();" class="continue-shopping-button">' + continueShopping + '</a></div>');

   openModal();

   // Update cart count bubble in header
   $('.cart-count-bubble').css("visibility", "visible");

   if ($('.cart-count-bubble span').text().length) {
      let cartCount = parseInt($('.cart-count-bubble span').text());
      $('.cart-count-bubble span').text( cartCount + quantity );
   } else {
       $('.cart-count-bubble span').text(quantity);
   }

}

function addToCartFail(obj, status) {
   const unavailable = 'Sorry, this product is not available currently.';
   $('.cart-preview-modal-content').html('<h2 style="margin-top: 4px; margin-bottom: 15px; font-weight: 700; color: #000000;">' + unavailable + '</h2>');
   openModal();
}

function openModal(){
   $('.cart-preview-modal').removeClass('hidden').addClass('open');
}

function closeModal(){
   $('.cart-preview-modal.open').addClass('hidden').removeClass('open');
}
